import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants"; // Import API constants

export default function ManageSubjects() {
  const [subjects, setSubjects] = useState([]);
  const [subjectName, setSubjectName] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchSubjects();
  }, []);

  const getAuthToken = () => localStorage.getItem("authToken"); // Retrieve token from localStorage

  const fetchSubjects = async () => {
    try {
      const token = getAuthToken();
      if (!token) {
        console.error("No authentication token found");
        return;
      }

      const response = await axios.get(`${appConstants.API_ROOT_URL}/get-subjects`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSubjects(response.data.data);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = getAuthToken();
      if (!token) {
        console.error("No authentication token found");
        return;
      }

      const url = editId ? `${appConstants.API_ROOT_URL}/update-subject` : `${appConstants.API_ROOT_URL}/create-subject`;
      await axios.post(
        url,
        { id: editId, name: subjectName },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      handleCancel(); // Reset form after submission
      fetchSubjects();
    } catch (error) {
      console.error("Error saving subject:", error);
    }
  };

  const handleEdit = (subject) => {
    setSubjectName(subject.name);
    setEditId(subject.id);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this subject?")) {
      try {
        const token = getAuthToken();
        if (!token) {
          console.error("No authentication token found");
          return;
        }

        await axios.post(
          `${appConstants.API_ROOT_URL}/delete-subject`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        fetchSubjects();
      } catch (error) {
        console.error("Error deleting subject:", error);
      }
    }
  };

  const handleCancel = () => {
    setSubjectName("");
    setEditId(null);
  };

  return (
    <Layout>
      <h2>Manage Subjects</h2>
      <form onSubmit={handleSubmit} className="mb-3">
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Enter subject name"
          value={subjectName}
          onChange={(e) => setSubjectName(e.target.value)}
          required
        />
        <button type="submit" className="btn btn-primary me-2">
          {editId ? "Update Subject" : "Add Subject"}
        </button>
        {editId && (
          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
        )}
      </form>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {subjects.map((subject) => (
            <tr key={subject.id}>
              <td>{subject.id}</td>
              <td>{subject.name}</td>
              <td>
                <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(subject)}>
                  Edit
                </button>
                <button style={{ display: "none" }} className="btn btn-danger btn-sm" onClick={() => handleDelete(subject.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Layout>
  );
}
